import request from "@/axios";

/** 获取可选的的关联应用接口 */
export const getApps = () => {
  return request({
    url: "/lebo-card/AppCardThirdPartyApp/getAll",
    method: "get",

  });
}

/** 分页的接口 */
export const getAppCardList = (params) => {
  return request({
    url: "/lebo-card/addCard/page",
    method: "get",
    params
  });
}

/** 新增的接口 */
export const addAppCard = (data) => {
  return request({
    url: "/lebo-card/addCard/save",
    method: "post",
    data
  });
}

/** 删除的接口 */
export const deleteAppCard = (id) => {
  return request({
    url: `/lebo-card/addCard/remove`,
    method: "post",
    params: {
      ids: id
    }
  });
}

/** 获取已上架的影视内容列表 */
export const getContentList = (params) => {
  return request({
    url: `/lebo-card/web/recomendMedia/page`,
    method: "get",
    params: {
      ...params,
      status: 1
    }
  });
}

/** 获取卡片详情的接口 */
export const getAppCardDetail = (id) => {
  return request({
    url: `/lebo-card/addCard/info?`,
    method: "get",
    params: {
      id
    }
  });
}

/** 修改卡片的接口 */
export const updateAppCard = (data) => {
  return request({
    url: '/lebo-card/addCard/update',
    method: 'post',
    data
  })
}

/** 添加频道的接口 */
export const addChannel = (data) => {
  return request({
    url: '/lebo-card/app_card_tab',
    method: 'post',
    data
  })
}

/** 编辑频道的接口 */
export const updateChannel = (data) => {
  return request({
    url: '/lebo-card/app_card_tab',
    method: 'put',
    data
  })
}

/** 删除频道的接口 */
export const deleteChannel = (ids) => {
  return request({
    url: `/lebo-card/app_card_tab/delete`,
    method: 'post',
    data: ids
  })
}

/** 查看日志的接口 */
export const getLogList = (params) => {
  return request({
    url: "/lebo-card/web/card/operation-log/page",
    method: "get",
    params: {
      ...params,
      module: 2
    }
  });
}

/** 获取已上架的赛程内容列表接口 */
export const getMatchList = (params) => {
  return request({
    url: `/lebo-card/web/recomendMedia/page`,
    method: "get",
    params: {
      ...params,
      status: 1,
      // 类型（1：影视；2：比赛）
      type: 2
    }
  });
}
//^ ^--------------追剧内容卡片-------------^ ^
/** 获取业务字典中的卡片状态 */
export const getDisplayStatus = () => {
  return request({
    url: "/lebo-system/dict-biz/dictionary",
    method: "get",
    params: {
      code: "app_card_third_party_app_display_status"
    }
  });
}
